<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">{{ $t('longOfflineStatistics.长期未联网') }}</span>
      <div style="flex:1;text-align: right;">
        <quickQuery :isDownload="true" @handleQuery="onQuery" @quickQuery="onQuery" @download="onExport"
          style="text-align: right" :timeShow="false" />
      </div>

    </div>
    <el-divider></el-divider>

    <!-- 数据表格 -->
    <div class="page_container">
      <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">

        <el-table-column prop="CarNo" align="center" :label="$t('longOfflineStatistics.车牌号')"
          min-width="120"></el-table-column>
        <el-table-column prop="DeviceNo" align="center" :label="$t('longOfflineStatistics.终端编号')" min-width="100">

        </el-table-column>
        <el-table-column prop="VehicleModel" align="center" :label="$t('longOfflineStatistics.车型')"
          min-width="160"></el-table-column>
        <el-table-column prop="GpsDateTime" align="center" :label="$t('longOfflineStatistics.最后上线时间')"
          min-width="160"></el-table-column>

        <el-table-column prop="Position" align="center" :label="$t('longOfflineStatistics.最后上线位置')" min-width="180">
        </el-table-column>
        <el-table-column prop="OffLineDay" align="center" :label="$t('longOfflineStatistics.离线天数')" min-width="120">
        </el-table-column>


      </el-table>
      <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total" @current-change="pageChange"
        :current-page.sync="form.PageNo" @size-change="sizeChange">
      </kl-pagination>
    </div>


  </div>
</template>

<script>
import quickQuery from "../components/generalOrQuickQuery.vue";
import { queryLongStayRec } from '@/http/vehicle'
import language from '@/utils/getLanguageId';
import { mapState } from 'vuex'
export default {
  name: 'LongOfflineStatistics',
  components: {
    quickQuery
  },
  computed: {
    LanguageId() {
      return language(this.$store.getters.locale)
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  data() {
    return {
      // 搜索表单
      form: {
        PageNo: 1,
        PageSize: 10
      },
      loading: false,
      beginDate: undefined,
      endDate: undefined,
      // 表格数据
      tableData: [],
      total: 0,

    }
  },
  mounted() {

  },
  methods: {
    getSelectedVehicles() {
      let vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    onExport() {

      //数据导出
      this.loadData(1);
    },
    onQuery(val) {
      this.beginDate = val.beginDate;
      this.endDate = val.endDate;
      this.loadData();
    },
    // 加载数据
    loadData(isExport) {
      isExport = isExport || 0;
      this.loading = true

      // 实际项目中取消注释以下代码
      queryLongStayRec({
        "BegiBeginDatenTime": this.beginDate,
        "Language": this.LanguageId,

        "EndDate": this.endDate,
        "IsExport": isExport,
        "PageNo": this.form.PageNo, "PageSize": this.form.PageSize
      }, isExport == 1 ? 'blob' : 'json').then(res => {
        this.loading = false
        if (isExport == 1) {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码

          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = this.$t('longOfflineStatistics.长期未联网') + "_" + this.moment(new Date()).format('YYYY-MM-DD') + '.xlsx'; // 默认文件名
       
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
        } else {

          this.tableData = res.data || []
          this.total = res.recordsTotal || 0

        }
      })



    },
    sizeChange(size) {
      this.form.PageSize = size;
      this.loadData();
    },
    // 分页变化
    pageChange(page) {
      this.form.PageNo = page;
      this.loadData();
    },
  }
}
</script>

<style scoped>
/* 响应式设计 */
</style>